import request from '@/utils/request'

// fwUpdate页
// 上传文件
export function uploadFile(params) {
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/deviceSystemVersion/uploadFile',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 上传新版本--提交
export function addVersionFile(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/addVersionFile',
    method: 'post',
    data: params
  })
}
// 编辑版本描述--提交
export function updateVersionFile(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/updateVersionFile',
    method: 'post',
    data: params
  })
}
// 版本--删除
export function deleteVersion(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/delete',
    method: 'post',
    data: params
  })
}
// 更新固件--主页---
// 列表--分页
export function getUpdateDeviceList(params) {
  return request({
    url: '/v3/manager/deviceSystemVersion/getUpdateDeviceList',
    method: 'post',
    data: params
  })
}
// 全部公司
export function allCompanyList(param) {
  return request({
    url: '/v3/user/company/allCompanyList',
    method: 'get'
  })
}
// 下拉框--归属公司
export function listByCompanyParentId(params) {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}
// 获取最后一条getLastMessageBootReq数据
export function getLastMessageBootReq(param) {
  return request({
    url: '/v3/manager/configData/getLastMessageBootReq?mcuId=' + param.mcuId,
    method: 'get'
  })
}
// 手动刷新联网卡列表
export function manualUpdateSimList(params) {
  return request({
    url: 'v3/manager/iot263/manualUpdateSimList',
    method: 'get',
    data: params
  })
}
// yhub页--详情页---
// 全部设备
export function getUpdateDeviceDetail(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/getUpdateDeviceDetail?mcuId=' + params.mcuId,
    method: 'get'
  })
}
// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
export function sysDictInfo(params) { // 选择设备类型下拉框
  return request({
    url: 'v3/manager/sysDict/sysDictInfo',
    method: 'get',
    params: params
  })
}
// 版本更新历史记录
export function getUpdateVersionLog(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/getUpdateVersionLog',
    method: 'post',
    data: params
  })
}
// 配置更新历史记录
export function pageYhubConfigLog(params) {
  return request({
    url: 'v3/manager/pageYhubConfigLog',
    method: 'post',
    data: params
  })
}
// 远程更新历史记录
export function pageRemoteControlRecord(params) {
  return request({
    url: 'v3/report/pageRemoteControlRecord',
    method: 'post',
    data: params
  })
}
// 获取最后的bms数据
export function getLastBMSRecor2(params) {
  return request({
    url: 'v3/report/getLastBMSRecor2?mcuId=' + params.mcuId,
    method: 'get',
    data: params
  })
}
// 获取最后的bms数据
export function getLastBMSRecor(params) {
  return request({
    url: 'v3/canbus/bmsRecord/getLastBMSRecor?mcuId=' + params.mcuId,
    method: 'get',
    data: params
  })
}
// 弹窗--固件版本列表
export function pageDeviceSystemVersionList(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/pageDeviceSystemVersionList2',
    method: 'post',
    data: params
  })
}
// 获取固件版本
export function deviceModelList(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/deviceModelList',
    method: 'get',
    data: params
  })
}
// 弹窗--发送更新
export function PushUpdateIndex(params) {
  return request({
    url: 'v3/device/mqtt/PushUpdateIndex',
    method: 'post',
    data: params
  })
}
// 弹窗--发送更新
export function deviceUpdateVersion(params) {
  var oldV = params.oldVersion || 0
  return request({
    url: 'v3/manager/device/deviceUpdateVersion/' + params.mcuId + '/' + params.deviceId + '/' + params.versionId + '/' + oldV,
    method: 'post'
    // data: params
  })
}
// 全部设备列表--更新状态
export function updateLogStatus(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/updateLogStatus',
    method: 'post',
    data: params
  })
}
// 物联网卡信息--by MCUID
export function getMhxqByMcuId(params) {
  return request({
    url: 'v3/manager/iot263/getMhxqByMcuId?mcuId=' + params.mcuId,
    method: 'get',
    data: params
  })
}
// 物联网卡信息
export function getMhxq(params) {
  return request({
    url: 'v3/manager/iot263/getMhxq?iccId=' + params.iccId,
    method: 'get',
    data: params
  })
}
// 固件版本历史
export function deviceSystemVersionHistory(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/deviceSystemVersionHistory?deviceModel=' + params.deviceModel,
    method: 'get'
  })
}
// 数据迁移
export function doCopyData(params) {
  return request({
    url: 'v3/manager/yhubData/copy',
    method: 'post',
    data: params
  })
}

export function FWDownload (name) {
  const url = '/v3/manager/deviceSystemVersion/FWDownload/' + name
  // console.log(process.env.VUE_APP_BASE_API)
  open(process.env.VUE_APP_BASE_API + url)
 
}